import React, { useState, useEffect } from "react";
import { Grid } from "@progress/kendo-react-grid";
import "./DataGrid.css";

const DataGrid = ({ ref, ...props }) => {
    const {
        data = [],
        sortable = true,
        filterable = false,
        resizable = false,
        scrollable = 'scrollable',
        style = { height: "400px" },
        children,
        pageSizes = [5, 10, 20, 50, 100, 200],
        pageSizeValue = 20,
        skipInitialLoad = false,
        ...otherProps
    } = props;

    const [initialLoadSkipped, setInitialLoadSkipped] = useState(false);
    const [gridState, setGridState] = useState({
        sortable,
        filterable,
        pageable: {
            pageSizes,
            pageSizeValue,
        },
        filter: null,
        sort: [],
        group: [],
        skip: 0,
        take: 20
    });

    const handleDataStateChange = async (event) => {
        const { dataState } = event;

        await setGridState({
            ...gridState,
            ...dataState,
            pageable: {
                ...gridState.pageable,
                pageSizeValue: dataState.take,
            }
        });
    };


    const reload = () => {
        const resetState = {
            ...gridState,
            sort: [],
            filter: null,
            group: [],
            skip: 0,
            take: pageSizeValue
        };
        setGridState(resetState);
    };

    // Assign reload and updateData to ref if one is supplied
    useEffect(() => {
        if (ref) {
            if (typeof ref === 'function') {
                ref({ reload });
            } else {
                ref.current = { reload };
            }
        }
    });

    // Notify parent of state changes
    useEffect(() => {
        if (skipInitialLoad && initialLoadSkipped === false) {
            setInitialLoadSkipped(true);
        } else {
            props.onChange(gridState);
        }
    }, [gridState]);

    return (
        <Grid
            data={data}
            sortable={gridState.sortable}
            resizable={gridState.resizable}
            pageable={gridState.pageable}
            scrollable={gridState.scrollable}
            sort={gridState.sort}
            filter={gridState.filter}
            group={gridState.group}
            skip={gridState.skip}
            take={gridState.take}
            onDataStateChange={handleDataStateChange}
            {...otherProps}
        >
            {children}
        </Grid>
    );
};

export default DataGrid;